import { CSSProperties, useRef, useState } from 'react'
import { format, getQuarter } from 'date-fns'
import css from './datePicker.module.css'
import DateDropdown from '../DateDropdown'
import SwapRight from '../../../../assets/icons/swapRight.svg?react'
import CalendarOutlined from '../../../../assets/icons/calendarOutlined.svg?react'
import usePopup from '../../../hooks/usePopup.ts'

interface IProps {
  value?: Date
  secondValue?: Date
  type?: 'date' | 'month' | 'quarter' | 'year'
  disabled?: boolean
  range?: boolean
  footer?: boolean
  double?: boolean
  isShowTime?: boolean
  onChange?: (date: Date | [Date, Date]) => void
  style?: CSSProperties
}

const DatePicker = ({
  value = null,
  secondValue = null,
  type = 'date',
  range = false,
  double = false,
  isShowTime = false,
  disabled = false,
  footer = false,
  onChange,
  style,
}: IProps) => {
  const [isSelectingStartDate, setIsSelectingStartDate] = useState(true)
  const containerRef = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(containerRef)

  const toggleDropdown = () => {
    if (!disabled) {
      setOpen((prev) => !prev)
    }
  }

  const handleSegmentClick = (isStart: boolean, e: React.MouseEvent) => {
    e.stopPropagation()
    if (!disabled) {
      setIsSelectingStartDate(isStart)
      setOpen(true)
    }
  }

  const getFormattedDate = (date: Date | null): string => {
    if (!date) return ''
    switch (type) {
      case 'date':
        return format(date, isShowTime ? 'dd.MM.yyyy, HH:mm:ss' : 'dd.MM.yyyy')
      case 'month':
        return format(date, 'MMM yyyy')
      case 'quarter':
        return `Q${getQuarter(date)} ${format(date, 'yyyy')}`
      case 'year':
        return format(date, 'yyyy')
      default:
        return ''
    }
  }

  const renderSegment = (date: Date | null, placeholder: string, isStart?: boolean) => (
    <div
      className={`${css.dateSegment} ${date ? css.dateValue : css.placeholder}`}
      onClick={(e) => isStart !== undefined && handleSegmentClick(isStart, e)}
    >
      {date ? getFormattedDate(date) : placeholder}
    </div>
  )

  const renderRange = () => {
    return (
      <>
        {renderSegment(value, 'Дата начала', true)}
        <SwapRight className={css.iconWrapperSwap} />
        {renderSegment(secondValue, 'Дата конца', false)}
      </>
    )
  }

  return (
    <div
      className={`${css.datePicker} ${disabled && css.disabled} ${open && !disabled && css.focused}`}
      onClick={toggleDropdown}
      ref={containerRef}
      style={style}
    >
      <div className={css.containerValue}>{range ? renderRange() : renderSegment(value, 'Выберите дату')}</div>
      <div className={css.iconWrapper}>
        <CalendarOutlined />
      </div>
      <DateDropdown
        startDate={value}
        endDate={secondValue}
        isSelectingStartDate={isSelectingStartDate}
        type={type}
        range={range}
        double={double}
        footer={footer}
        isShowTime={isShowTime}
        onChange={onChange}
        open={open}
      />
    </div>
  )
}

export default DatePicker
